import { IStoryItem } from 'interfaces/addStory.interface';
import { FC, useState } from 'react';
import 'react-resizable/css/styles.css';
import GifSearchCont from '../SearchGifsBody';
import StoryLinkMenu from '../StoryLinkMenu';
import StoryMentionMenu from '../StoryMentionMenu';
import StoryMainMenuCont from '../StoryMainMenu';
import './StoryMenu.css';
import { MainBody, Overlay } from './StoryMenu.styles';

interface IStoryMenu {
  addToStoryBoard?: (data: IStoryItem) => void;
  hideUI: () => void;
}

const StoryMenu: FC<IStoryMenu> = ({ addToStoryBoard, hideUI }) => {
  const [showMentionMenu, setShowMentionMenu] = useState<boolean>(false);
  const [showGifMenu, setShowGifMenu] = useState<boolean>(false);
  const [showLinkMenu, setShowLinkMenu] = useState<boolean>(false);

  const handleShowMentionMenu = () => {
    setShowMentionMenu(true);
  };

  const handleShowGifMenu = () => {
    setShowGifMenu(true);
  };

  const handleShowLinkMenu = () => {
    setShowLinkMenu(true);
  };

  return (
    <MainBody>
      {showMentionMenu ? (
        <StoryMentionMenu addToStoryBoard={addToStoryBoard} hideUI={hideUI} />
      ) : showGifMenu ? (
        <GifSearchCont
          addToStoryBoard={addToStoryBoard}
          hideUI={hideUI}
          apiKey="mFtieOUQ9LwBSrl19osQJPeuiTnm3ZSw"
          onSelect={(item: any) => console.log(item)}
        />
      ) : showLinkMenu ? (
        <StoryLinkMenu addToStoryBoard={addToStoryBoard} hideUI={hideUI} />
      ) : (
        <StoryMainMenuCont
          apiKey="mFtieOUQ9LwBSrl19osQJPeuiTnm3ZSw"
          addToStoryBoard={addToStoryBoard}
          showMentionMenu={handleShowMentionMenu}
          showGifMenu={handleShowGifMenu}
          showLinkMenu={handleShowLinkMenu}
          hideUI={hideUI}
        />
      )}
      <Overlay onClick={hideUI} />
    </MainBody>
  );
};

export default StoryMenu;
